import {api} from "@/app/services/api.service";

const state = {
    non_individual_affiliationss: null,
    non_individual_affiliationss_scheduled: null,
    escalations: [],
    non_individual_affiliationsStatuses: null,
    non_individual_affiliations_task: {},
    non_individual_affiliations_task_error: null,
    non_individual_affiliations_details: null,
    non_individual_affiliations_stats: {},
    non_individual_affiliations_count: {},
    success: {},
    successAssignmentDr: {},
    disputeSuccessEscalation: {},
    errorAssignment: {},
    successStatusUpdate: {},
    dispute_error: null,
};

const getters = {
    getNonIndividualAffiliationsSubmissions: (state) => state.non_individual_affiliationss,
    getScheduledNonIndividualAffiliationsSubmissions: (state) => state.non_individual_affiliationss_scheduled,
    getNonIndividualAffiliationsEscalations: (state) => state.escalations,
    getNonIndividualAffiliationsTask: (state) => state.non_individual_affiliations_task,
    getNonIndividualAffiliationsTaskError: (state) => state.non_individual_affiliations_task_error,
    getNonIndividualAffiliationsDetails: (state) => state.non_individual_affiliations_details,
    getNonIndividualAffiliationsStatistics: (state) => state.non_individual_affiliations_stats,
    getNonIndividualAffiliationsStatuses: (state) => state.non_individual_affiliationsStatuses,
    getNonIndividualAffiliationsStatusUpdate: (state) => state.successStatusUpdate,
    getNonIndividualAffiliationsCount: (state) => state.non_individual_affiliations_count,
    getNonIndividualAffiliationsSuccess: (state) => state.success,
    getNonIndividualAffiliationsEscalationSuccess: (state) => state.disputeSuccessEscalation,
    getNonIndividualAffiliationsAssignmentSuccess: (state) => state.successAssignmentDr,
    getNonIndividualAffiliationsAssignmentError: (state) => state.errorAssignment,
    getNonIndividualAffiliationsError: (state) => state.dispute_error,
    getNonIndividualAffiliationsEscalationError: (state) => state.dispute_error,
};

const actions = {
    async submitNonIndividualAffiliationsApplicationPayment({commit}, data) {
        await api().post("/nir/api/v1/non-individual-affiliations/disputes/add-payment", data)
            .then((response) => {
                commit("setNonIndividualAffiliations", response.data);
            })
            .catch((error) => {
                commit("setNonIndividualAffiliationsTaskError", error.response);
            });
    },
    async fetchNonIndividualAffiliationsSubmissions({commit}, data) {
        let path =
          "/affiliations?status=" +
          data.statuses +
          "&page=" +
          data.page +
          "&limit=" +
          data.limit;
        if (data.search !== "") {
            path += "&search=" + data.search
        }
        api()
          .get("/nir/api/v1/" + path)
          .then(response => {
            commit("setNonIndividualAffiliationss", response.data);
          })
          .catch(error => {
            commit("setNonIndividualAffiliationsError", error.response);
          });
    },
    async fetchNonIndividualAffiliationsEscalations({commit}, data) {
        api().get("/nir/api/v1/affiliations/escalations?userId=" + data.userId + "&page=" + data.page + "&perPage=" + data.limit).then(response => {
            commit('setCFEscalations', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsEscalationError", error.response)
        });
    },
    async fetchNonIndividualAffiliationsStatuses({commit}, id) {
        api().get("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/tasks/" + id + "/thread").then(response => {
            commit('setNonIndividualAffiliationsStatuses', response);
        }).catch(error => {
            commit("setNonIndividualAffiliationsError", error.response)
        });
    },
    async fetchNextNonIndividualAffiliations({commit},userId ) {
        commit('setNonIndividualAffiliationsToNull');
        let url = "nir/api/v1/affiliations/next?userId="+userId;

        api().get(url).then(response => {
            commit('setNonIndividualAffiliations', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsError", error.response)
        });
    },
    async fetchNonIndividualAffiliationsDetails({commit}, trackingNumber) {
        api()
          .get(
            "/nir/api/v1/affiliations/task?id=" + trackingNumber
          )
          .then(response => {
            commit("setNonIndividualAffiliationsDetails", response.data);
          })
          .catch(error => {
            commit("setNonIndividualAffiliationsError", error.response);
          });
    },
    async fetchNonIndividualAffiliationsStats({commit}) {
        api()
          .get("/nir/api/v1/affiliations/stats")
          .then(response => {
            commit("setNonIndividualAffiliationsStats", response.data);
          })
          .catch(error => {
            commit("setNonIndividualAffiliationsError", error.response);
          });
    },
    async fetchNonIndividualAffiliationsCount({commit}) {
        api().get("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/tasks/count").then(response => {
            commit('setNonIndividualAffiliationsCount', response);
        }).catch(error => {
            commit("setNonIndividualAffiliationsError", error.response)
        });
    },
    updateNonIndividualAffiliationsStatus({commit}, data) {
        api().post("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/tasks/" + data.id+"/task",     {status: data.status,
            rationale:data.rationale
    }).then(response => {
            commit('setNonIndividualAffiliationsStatusUpdated', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsAssignmentError", error.response)
        });
    },
    approveNonIndividualAffiliationsApplication({commit}, data) {
        api().post("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/tasks/" + data.get("id") + "/receive", data).then(response => {
            commit('setNonIndividualAffiliationsStatusUpdated', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsAssignmentError", error.response)
        });
    },
    queryNonIndividualAffiliationsChargeStatus({commit}, data) {
        api().post("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/queue/query-for-payment", data).then(response => {
            commit('setNonIndividualAffiliationsStatusUpdated', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsAssignmentError", error.response)
        });
    },
    rejectNonIndividualAffiliationsChargeStatus({commit}, data) {
        api().post("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/queue/query-for-payment", data).then(response => {
            commit('setNonIndividualAffiliationsStatusUpdated', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsAssignmentError", error.response)
        });
    },
    assignNonIndividualAffiliationsTask({commit}, data) {
        api().post("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/tasks/assign-task", data).then(response => {
            commit('setNonIndividualAffiliationsAssignmentAction', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsError", error.response)
        });
    },
    assignEscalationNonIndividualAffiliationsTask({commit}, data) {
        api().post("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/escalation/queue/re-assign", data).then(response => {
            commit('setNonIndividualAffiliationsAssignmentAction', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsError", error.response)
        });
    },
    escalateNonIndividualAffiliationsTask({commit}, data) {
        api().post("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/tasks/"+data.taskId+"/escalate", data).then(response => {
            commit('setNonIndividualAffiliationsEscalationAction', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsError", error.response)
        });
    },
    reEscalateNonIndividualAffiliationsTask({commit}, data) {
        api().post("/nir/api/v1/non-individual-affiliations/non-individual-affiliationss/queue/escalate", data).then(response => {
            commit('setNonIndividualAffiliationsEscalationAction', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsError", error.response)
        });
    },
    async fetchScheduledNonIndividualAffiliationss({commit}, data) {
        let path = "/nir/api/v1/non-individual-affiliations/scheduled/events?status=" + data.statuses + "&page=" + data.page + "&size=" + data.limit +"&type="+data.type
    /*    if (data.search) {
            path += "&search=" + data.search
        }*/
        api().get(path).then(response => {
            commit('setScheduledNonIndividualAffiliationss', response.data);
        }).catch(error => {
            commit("setNonIndividualAffiliationsError", error.response)
        });
    },
};

const mutations = {
    setNonIndividualAffiliationss: (state, response) => {
        state.non_individual_affiliationss = response.data;
    }, setScheduledNonIndividualAffiliationss: (state, response) => {
        state.non_individual_affiliationss_scheduled = response;
    },
    setCFEscalations: (state, response) => {
        state.escalations = response;
    },
    setNonIndividualAffiliations: (state, response) => {
        state.non_individual_affiliations_task = response;
    },
    setNonIndividualAffiliationsTaskError: (state, error) => {
        state.non_individual_affiliations_task_error = error;
    },
    setNonIndividualAffiliationsDetails: (state, response) => {
        state.non_individual_affiliations_details = response;
    },
    setNonIndividualAffiliationsToNull: (state) => {
        state.non_individual_affiliations = null;
    },
    setNonIndividualAffiliationsStatuses: (state, response) => {
        state.non_individual_affiliationsStatuses = response.data;
    },
    setNonIndividualAffiliationsStats: (state, response) => {
        state.non_individual_affiliations_stats = response.data;
    },
    setNonIndividualAffiliationsCount: (state, response) => {
        state.non_individual_affiliations_count = response.data;
    },
    setNonIndividualAffiliationsAction: (state, response) => {
        state.success = response;
    },
    setNonIndividualAffiliationsAssignmentAction: (state, response) => {
        state.successAssignmentDr = response;
    },
    setNonIndividualAffiliationsStatusUpdated: (state, response) => {
        state.successStatusUpdate = response;
    },
    setNonIndividualAffiliationsEscalationAction: (state, response) => {
        state.disputeSuccessEscalation = response;
    },
    setNonIndividualAffiliationsError: (state, error) => {
        state.dispute_error = error.data;
    },
    setNonIndividualAffiliationsEscalationError: (state, error) => {
        state.dispute_error = error.data;
    },
    setNonIndividualAffiliationsAssignmentError: (state, error) => {
        state.errorAssignment = error;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};